export const findSelectedOptions = (options: string | undefined) => {
  let selectedOptions: Array<number> = [];
  if (!options) return selectedOptions; // return early if no options are provided
  options
    .split(",")
    .map((option: string) => selectedOptions.push(option.charCodeAt(0) - 65));

  return selectedOptions;
};
